"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var codemirror_1 = __importDefault(require("codemirror"));

require("codemirror/addon/hint/show-hint");

require("codemirror/addon/mode/simple");

require("codemirror/addon/scroll/simplescrollbars");

var react_1 = __importStar(require("react"));

var Buffer_1 = require("../models/Buffer");

var actions = __importStar(require("./actions"));

var FormulaEditorField =
/** @class */
function (_super) {
  __extends(FormulaEditorField, _super);

  function FormulaEditorField() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.editor = null;
    _this.editorRef = react_1.createRef();
    _this.cachedOffset = null;
    _this.lastBuffer = _this.props.buffer;

    _this.showHint = function () {
      var _a = _this.props,
          completions = _a.completions,
          disabled = _a.disabled;

      if (disabled) {
        return;
      } // @ts-ignore


      var hinter = codemirror_1.default.hint[_this.props.language];

      if (!hinter) {
        return;
      }

      var hintOptions = hinter(completions, _this.onCodeHintShow, _this.onCodeHintHide);

      if (hintOptions) {
        // @ts-ignore
        _this.editor.showHint(hintOptions);
      }
    };

    _this.onChange = function (instance, changes) {
      var _a = _this.props,
          buffer = _a.buffer,
          dispatch = _a.dispatch;
      var newBuffer = changes.reduce(function (prev, curr) {
        var from = {
          col: curr.from.ch,
          row: curr.from.line
        };
        var to = {
          col: curr.to.ch,
          row: curr.to.line
        };
        return Buffer_1.Buffer.replace(prev, from, to, curr.text);
      }, buffer);

      _this.showHint();

      _this.lastBuffer = newBuffer;
      dispatch(actions.changeBuffer(newBuffer));
    };

    _this.onCodeHintHide = function () {
      var dispatch = _this.props.dispatch;
      dispatch(actions.closeHints());
    };

    _this.onCodeHintShow = function (result) {
      var dispatch = _this.props.dispatch;
      dispatch(actions.showHints(result.hints));
    };

    _this.onMount = function (element) {
      if (_this.editorRef.current) {
        _this.editorRef.current.append(element);
      }
    };

    _this.onUpdateHeight = function (instance) {
      var _a = _this.props,
          minLines = _a.minLines,
          maxLines = _a.maxLines;

      var offset = _this.getOffset();

      var lineCount = instance.getDoc().lineCount();
      var totalHeight = instance.heightAtLine(lineCount, 'local');
      var defaultLineHeight = instance.defaultTextHeight();
      var minHeight = minLines && minLines * defaultLineHeight + offset;
      var maxHeight = maxLines && maxLines * defaultLineHeight + offset;
      var height = Math.max(minHeight || totalHeight, Math.min(totalHeight, maxHeight || totalHeight));
      var isCapped = minHeight === height || maxHeight === height;

      if (_this.editor) {
        var wrapper = _this.editor.getWrapperElement();

        wrapper.style.height = isCapped ? height + "px" : "auto";
      }
    };

    return _this;
  }

  FormulaEditorField.prototype.componentDidMount = function () {
    var _this = this;

    var _a = this.props,
        buffer = _a.buffer,
        disabled = _a.disabled,
        language = _a.language,
        maxLines = _a.maxLines;
    var options = {
      extraKeys: {
        'Ctrl-Space': function CtrlSpace() {
          return _this.showHint();
        }
      },
      lineWrapping: true,
      mode: language,
      readOnly: disabled ? 'nocursor' : false,
      scrollbarStyle: 'overlay',
      value: buffer.lines.join('\n'),
      viewportMargin: maxLines || Infinity
    };
    this.editor = codemirror_1.default(this.onMount, options);
    this.editor.on('changes', this.onChange);
    this.editor.on('change', this.onUpdateHeight);
    this.editor.on('refresh', this.onUpdateHeight);
    this.onUpdateHeight(this.editor);
  };

  FormulaEditorField.prototype.componentDidUpdate = function (prevProps) {
    var _a = this.props,
        buffer = _a.buffer,
        disabled = _a.disabled,
        language = _a.language,
        maxLines = _a.maxLines,
        showHints = _a.showHints;

    if (buffer !== this.lastBuffer) {
      this.forceContents(buffer);
    }

    if (this.editor && language !== prevProps.language) {
      this.editor.setOption('mode', language);
    }

    if (this.editor && showHints && !prevProps.showHints) {
      this.showHint();
    }

    if (this.editor && !showHints && prevProps.showHints) {
      this.closeHint();
    }

    if (this.editor && disabled && !prevProps.disabled) {
      this.editor.setOption('readOnly', 'nocursor');
    }

    if (this.editor && !disabled && prevProps.disabled) {
      this.editor.setOption('readOnly', false);
    }

    if (this.editor && maxLines !== prevProps.maxLines) {
      this.editor.setOption('viewportMargin', maxLines || Infinity);
    }
  };

  FormulaEditorField.prototype.componentWillUnmount = function () {
    if (this.editor) {
      this.editor.getWrapperElement().remove();
    }
  };

  FormulaEditorField.prototype.closeHint = function () {
    // @ts-ignore
    this.editor.closeHint();
  };

  FormulaEditorField.prototype.forceContents = function (buffer) {
    if (this.editor) {
      var value = buffer.lines.join('\n'); // Because the buffer is changed without the lastBuffer being updated, this *must* be updated.
      // If not, keystrokes will be eaten until the lastBuffer is updated.

      this.lastBuffer = buffer; // These all need to be disabled.
      // Otherwise, they'll repeatedly fire within the same update. This causes weird behaviors.

      this.editor.off('changes', this.onChange);
      this.editor.setValue(value);
      this.editor.getDoc().setSelection(codemirror_1.default.Pos(0, 0), codemirror_1.default.Pos(0, 0));
      this.editor.on('changes', this.onChange);
    }
  };

  FormulaEditorField.prototype.getOffset = function () {
    if (!this.editor || this.cachedOffset !== null) {
      return this.cachedOffset || 0;
    }

    var instance = this.editor.getWrapperElement();
    var lines = instance.getElementsByClassName('CodeMirror-lines').item(0);

    if (!lines) {
      return 0;
    }

    var linesInner = lines.children.item(0);

    if (!linesInner) {
      return 0;
    }

    var instanceOffset = instance.offsetHeight - instance.clientHeight;
    var linesOffset = lines.clientHeight - linesInner.clientHeight;
    var offset = (instanceOffset + linesOffset) / 2;
    this.cachedOffset = linesOffset === null ? null : offset;
    return offset;
  };

  FormulaEditorField.prototype.render = function () {
    return react_1.default.createElement("div", {
      className: "formula-editor__field",
      ref: this.editorRef
    });
  };

  return FormulaEditorField;
}(react_1.PureComponent);

exports.default = FormulaEditorField;